import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { FlightStatus } from 'pages';
import { SASElements } from 'components/SASElements';

function App() {
  return (
    <div className="App">
      <SASElements />
      <Router>
        <Switch>
          <Route exact path={`${process.env.PUBLIC_URL}`}>
            <FlightStatus />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
